import Profile from '@/classes/auth/Profile'

export default class User {
  constructor (id, username, fullName, profileType, profileTypeDisplay, profile, profiles) {
    this.id = id
    this.username = username
    this.fullName = fullName
    this.profileType = profileType
    this.profileTypeDisplay = profileTypeDisplay
    this.profile = profile
    this.profiles = profiles
  }

  static asUsers (json) {
    return json.map(user => {
      return User.asUser(user)
    })
  }

  static asUser (json) {
    return new User(
      json.id,
      json.username,
      json.get_full_name,
      json.profile_type,
      json.profileTypeDisplay,
      json.profile ? Profile.asProfile(json.profile) : {},
      json.profile_acl ? Profile.asProfiles(json.profile_acl) : []
    )
  }

  setUser (json) {
    Object.assign(this, User.asUser(json))
  }
}
